import {AuthTokens} from '../types';
import {hasTokenExpired} from './hasTokenExpired';

export const hasValidOrRefreshableTokens = (
  authTokens: AuthTokens | undefined,
) =>
  authTokens !== undefined &&
  (!hasTokenExpired(authTokens.accessToken) ||
    !hasTokenExpired(authTokens.refreshToken));
